import { apiClient } from '@shared/utils/api-client';
import type { CreateSellerStaffDto, SellerStaffAccess, UpdateSellerStaffDto } from '../types';

export const sellerStaffApi = {
  getAll: () => apiClient.get<SellerStaffAccess[]>('/seller-staff'),

  create: (data: CreateSellerStaffDto) =>
    apiClient.post<SellerStaffAccess>('/seller-staff', data),

  update: (id: number, data: UpdateSellerStaffDto) =>
    apiClient.patch<SellerStaffAccess>(`/seller-staff/${id}`, data),

  remove: (id: number) => apiClient.delete<{ ok: boolean }>(`/seller-staff/${id}`),
};
